import React, { useMemo } from 'react';
import { regexForWatchesCommands } from 'appConstants';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface ICodeField {
	changeCode(value: string): void;
}

const CodeField: React.FC<ICodeField> = ({ changeCode }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			() => ({
				validator(_, value) {
					if (value && !value.match(regexForWatchesCommands)) {
						return Promise.reject(new Error(t('watchesCode')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t],
	);

	return (
		<FormInput
			testId="CodeField"
			name="code"
			label="watchesCodeLabel"
			onChange={changeCode}
			validationRules={validationRules}
			placeholder="watchesCodePlaceholder"
			maxLength={7}
		/>
	);
};

export default React.memo(CodeField);
